<script setup lang="ts">

import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import PositionIcon from '@/components/Interface/PositionIcon.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

/**
 * Props
 */
const props = defineProps<{
  shipActionData: {
    action: string;
    targetX: number;
    targetY: number;
    targetPlayer: number;
    targetShip: number;
    data: {
      name?: string;
      type: number;
      typeVariantId: number;
      targetPlayer: number;
    }
  },
  eta: number
}>();

</script>

<template>
  <StandardCard top-padding="0" bottom-padding="1">
    <div class="flex justify-between text-subtext w-full">
      <div class="flex gap-4">
        <GenericIcon tooltip="Defend" type="shields" class="hidden md:inline"/>
        <div class="flex items-center">
          <div v-if="props.shipActionData.data && props.shipActionData.data.name">
            <span class="me-1">Defend <span class="">{{ props.shipActionData.data.name }}</span></span><PositionIcon :x="props.shipActionData.targetX" :y="props.shipActionData.targetY"/>
          </div>
          <div v-else>Defending at <PositionIcon :x="props.shipActionData.targetX" :y="props.shipActionData.targetY"/></div>
        </div>
      </div>
      <div class="flex-shrink-0 ps-2">
        
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style> 